export default __webpack_public_path__ + "assets/models/2273cc5bce322743ba1596dbe31b1101.glb";